import httpClient from '@/lib/httpClient.js'
import { handleFormError } from '@/utils/helpers.js'
import { useMutation } from '@tanstack/react-query'

export default function useForgotPassword({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const action = async ({ email }) => {
    const response = await httpClient.post('auth/forgot-password', {
      email,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
  })

  return {
    forgotPassword: mutation.mutateAsync,
    forgotPasswordStatus: mutation,
  }
  //   return useQuery({ queryKey: ['login'], queryFn: action })
}
